const customstype = {
    getlist: 'customstype/getlist',
    add: 'customstype/add',
    update: 'customstype/update',
    remove: 'customstype/remove',
    get: 'customstype/get',
    getall: 'customstype/getall-by-admin',
    clearcache: 'customstype/clear-cache',
}
export default customstype
